import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import Text from '@tamagoshi/core/Text';
import Input from '@tamagoshi/core/Input';
import { LinkListItem } from '@tamagoshi/core/LinkList';
import { getTranslations } from '@translations';
import { getFooterContext } from '@context';
import { useBodyOverflow } from '@hooks';
import { NewsletterSuccess, NewsletterButton } from './components';

import styles from './styles/index.module.scss';

const getError = (error, translations) => ({
  messageType: error ? 'error' : null,
  message: error
    ? translations(`footer.contact.newsletter.${error}.error`)
    : null,
});

const Newsletter = () => {
  const translations = getTranslations();
  const {
    isModalVisible,
    isB2B,
    baseUrl,
    emailAddress,
    error,
    onSubmitEmail,
    onChangeEmailAddress,
    onHideModal,
  } = getFooterContext();
  const { setBodyOverflow, releaseBodyOverflow } = useBodyOverflow();
  const [inputError, setInputError] = useState(error);
  const onChange = (event, value) => {
    onChangeEmailAddress(value);
    setInputError(null);
  };
  const subTextLinkClassName = cn({
    [styles.subTextLink]: true,
    [styles.subTextLinkPro]: isB2B,
  });
  const onEnter = event => {
    event.preventDefault();
    setBodyOverflow('hidden');
    onSubmitEmail(emailAddress, baseUrl, releaseBodyOverflow);
  };
  const onClose = () => {
    releaseBodyOverflow();
    onHideModal();
  };

  useEffect(() => {
    setInputError(error);
  }, [error]);

  return (
    <>
      <div className={styles.block}>
        <Text type="h4" weight="bold" className={styles.title}>
          {translations('footer.contact.newsletter.title')}
          <Text tag="span" type="small" className={styles.subHeading}>
            {translations('footer.contact.newsletter.sub.title')}
          </Text>
        </Text>
        <Text type="small" className={styles.subTitle}>
          {translations('footer.contact.newsletter.subtitle')}
        </Text>
        <div className={styles.container}>
          <Input
            {...getError(inputError, translations)}
            tag="div"
            name="email"
            id="footerNewsletterEmailInput"
            className={styles.input}
            messageClassName={styles.inputMessage}
            value={emailAddress}
            label={translations('footer.contact.newsletter.input.label')}
            onChange={onChange}
            onEnter={onEnter}
          />
          <NewsletterButton />
        </div>
        <Text type="tiny" className={styles.subText}>
          {translations('footer.contact.newsletter.subtext')}
          <LinkListItem
            tag="span"
            color="primary"
            target="_blank"
            href={`${translations(
              'footer.contact.newsletter.subtext.link.href',
            )}`}
            className={subTextLinkClassName}
          >
            &nbsp;{translations('footer.contact.newsletter.subtext.link')}
          </LinkListItem>
        </Text>
      </div>
      <NewsletterSuccess isVisible={isModalVisible} onClose={onClose} />
    </>
  );
};

Newsletter.displayName = 'Newsletter';

export default Newsletter;
